/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import PhoneFormatBehavior from '@/behaviors/PhoneFormatBehavior';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';
import { validateForm } from '@/util/ParsleyUtils';

import UpdateAWPackage1901Info from '../../services/UpdateAWPackage1901Info';

import tmplAWPackage1901InformationView from './AWPackage1901InformationView.hbs';

const AWPackage1901InformationView = View.extend({
  template: tmplAWPackage1901InformationView,

  ui: {
    information1901Form: '.information-1901-form',
    pocLastNameCustomer: '[name="pocLastNameCustomer"]',
    pocPhoneCustomer: '[name="pocPhoneCustomer"]',
    orgNameVendor: '[name="orgNameVendor"]',
    pocEmailCustomer: '[name="pocEmailCustomer"]',
    pocEmailVendor: '[name="pocEmailVendor"]',
    phoneFormat: '.phone-format',
  },

  behaviors: {
    telephone: PhoneFormatBehavior
  },

  onRender() {
    const awPackage = this.model.get('awPackage');
    const aw1901Info = this.model.get('awPackage1901Info');
    Syphon.deserialize(this.ui.information1901Form, awPackage);
    Syphon.deserialize(this.ui.information1901Form, aw1901Info);

    if (!this.model.get('editable')) {
      this.toggleForm(false);
    }
  },

  onAttach() {
    if (this.model.get('showValidation')) {
      this.validate();
    }
  },

  async validate() {
    try {
      await Promise.all([validateForm(this.ui.information1901Form)]);
      this.trigger('no:errors');
      return true;
    } catch (err) {
      this.trigger('has:errors');
      return false;
    }

  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  async onSave() {
    if (!this.model.get('editable')) {
      return;
    }

    const formData = Syphon.serialize(this.ui.information1901Form);
    formData.awPackageId = this.model.get('awPackage').id;

    try {
      await UpdateAWPackage1901Info(formData);
      showSuccessMessage({
        code: 'saveSuccess',
        title: 'Save Success',
        message: 'AW Package Information Saved.',
        hideAfter: 1
      });
    } catch (err) {
      showErrorMessage({
        errorCode: 'saveError',
        errorTitle: 'Save Error',
        errorMessage: 'Error Saving File.'
      });
      throw new Error(err);
    }
  }
});

export default AWPackage1901InformationView;
